import { searchServiceReducer } from './search/reducer';
import { hotelServiceReducer } from './hotel/reducer';
import { packageServiceReducer } from './package/reducer';
import { railPackageServiceReducer } from './railPackage/reducer';
import { combineReducers } from 'redux';
export var coreRootReducer = combineReducers({
    search: searchServiceReducer,
    hotel: hotelServiceReducer,
    package: packageServiceReducer,
    railPackage: railPackageServiceReducer
});
export default coreRootReducer;
